import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Reveal } from "../components/motion";
import { FAQS } from "../lib/content";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <div data-testid="faq-page" className="bg-cream">
      <section className="px-6 py-20 text-center">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-pinkdeep">Questions, answered</p>
          <h1 className="mt-5 font-display text-4xl font-medium text-navy sm:text-5xl">Everything parents ask us.</h1>
        </Reveal>
      </section>
      <section className="mx-auto max-w-3xl px-6 pb-24">
        <div className="divide-y divide-blush rounded-[2rem] bg-white px-7 shadow-[0_10px_40px_rgba(16,42,86,0.06)]" data-testid="faq-accordion">
          {FAQS.map(([q, a], i) => (
            <div key={q}>
              <button onClick={() => setOpen(open === i ? null : i)} data-testid={`faq-q-${i}`}
                aria-expanded={open === i}
                className="flex w-full items-center justify-between gap-4 py-5 text-left font-display text-lg font-semibold text-navy transition hover:text-pinkdeep">
                {q}
                <ChevronDown size={19} className={`shrink-0 text-pink transition-transform ${open === i ? "rotate-180" : ""}`} />
              </button>
              {open === i && <p className="pb-6 text-sm leading-relaxed text-navy/60" data-testid={`faq-a-${i}`}>{a}</p>}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
